import { ReportDetailsRoot } from 'app/common/templates-next/report-template'

import { TableByPaymentMethodSimple } from './TableByPaymentMethodSimple'
import { TableByPaymentMethodSplitted } from './TableByPaymentMethodSplitted'
import { ByPaymentReportData, ByPaymentMethodTotals } from './types'

export const ResultByPaymentMethod = ({
  data,
  dateFormat = 'YYYY-MM-DD',
  splitByDays,
}: {
  data: ByPaymentReportData
  dateFormat?: string
  splitByDays: boolean
}) => {
  const totals: ByPaymentMethodTotals = {
    ...data.payment_methods,
    grand_total: data.grand_total,
  }

  return (
    <ReportDetailsRoot header={'Детализация отчета «Продажи»'}>
      {splitByDays ? (
        <TableByPaymentMethodSplitted
          dates={data.dates}
          schools={data.payment_methods_by_school}
          totals={totals}
          dateFormat={dateFormat}
        />
      ) : (
        <TableByPaymentMethodSimple schools={data.payment_methods_by_school} totals={totals} />
      )}
    </ReportDetailsRoot>
  )
}
